// extracted by mini-css-extract-plugin
export default {"card":"Card_card__EdDrk","overlay":"Card_overlay__34Qd0","fade-in":"Card_fade-in__KfuiE","dropdown":"Card_dropdown__wjuM4"};